import React from "react";
import { 
  faChartPie, 
  faSchool,
  faUsers
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from '@themesberg/react-bootstrap';
import { Routes } from "../../routes";

export const MunicipalSecretaryMenuItems = ({ NavItem }) => {
  return (
    <>
      <NavItem 
        title="Dashboard" 
        link={Routes.DashboardOverview.path} 
        icon={faChartPie} 
      />

      <Dropdown.Divider className="my-3 border-indigo" />

      <NavItem 
        title="Escolas" 
        link={Routes.MunicipalSchools.path} 
        icon={faSchool} 
      />

      <NavItem 
        title="Gestores" 
        link={Routes.MunicipalStaff.path} 
        icon={faUsers} 
      />
    </>
  );
};

export default MunicipalSecretaryMenuItems;
